import { useEffect } from 'react';
import { useThemePreferences } from '../contexts/ThemePreferencesContext';
import { changeAppLanguage } from '../i18n';

/** Synchronise la langue i18n avec les préférences utilisateur. */
export default function I18nLanguageSync() {
  const { language } = useThemePreferences();

  useEffect(() => {
    changeAppLanguage(language);
  }, [language]);

  return null;
}
